module.exports = __webpack_public_path__ + "3850bb33bfd29fc04449f4d2c29d34e7.svg";